import { usmle1BiochemModule } from "./biochem";
import { usmle1GeneticsModule } from "./genetics";
import { usmle1MicroModule } from "./micro";
import { usmle1ImmunologyModule } from "./immunology";
import { usmle1PharmModule } from "./pharm";
import { usmle1PathModule } from "./path";
import { usmle1PhysioModule } from "./physio";
import { usmle1BiostatsModule } from "./biostats";

export const usmle1Modules = [
  usmle1BiochemModule,
  usmle1GeneticsModule,
  usmle1MicroModule,
  usmle1ImmunologyModule,
  usmle1PharmModule,
  usmle1PathModule,
  usmle1PhysioModule,
  usmle1BiostatsModule,
];
